var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    stroke: "#4D4D4D",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9437 12.6493C19.7903 14.659 18.2218 16.2986 16.4998 16.2986C14.7779 16.2986 13.2066 14.6594 13.056 12.6493C12.8994 10.5585 14.4257 9 16.4998 9C18.574 9 20.1002 10.5966 19.9437 12.6493Z",
    stroke: "#4D4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24.0001C9.63946 20.5561 13.0951 18.7314 16.4998 18.7314C19.9045 18.7314 23.3601 20.5561 24 24.0001",
    stroke: "#4D4D4D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30.5C33 26.9115 30.0885 24 26.5 24C22.9115 24 20 26.9115 20 30.5C20 34.0885 22.9115 37 26.5 37C30.0885 37 33 34.0885 33 30.5Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28V33M29 30.5H24",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyUser);
export default __webpack_public_path__ + "static/media/icon-empty-user.5d937e58160ede0fc21869ee6b2f313c.svg";
export { ForwardRef as ReactComponent };